import { helpers } from 'veritone-redux-common';
import { Status } from './campaign/actions';
const { createReducer } = helpers;

export const namespace = 'emailTemplate';
export const GET_EMAIL_TEMPLATE = 'get email template setting saga';
export const SET_EMAIL_TEMPLATE = `${namespace}/SET_EMAIL_TEMPLATE`;
export const SET_EMAIL_TEMPLATE_STATUS = `${namespace}/SET_EMAIL_TEMPLATE_STATUS`;

const defaultState = {
  data: [],
  status: Status.INITIAL
};

const emailTemplateReducer = createReducer(defaultState, {
  [SET_EMAIL_TEMPLATE]: (state, action) => {
    const { data } = action.payload;
    return {
      ...state,
      data,
      status: Status.LOADED
    };
  },
  [SET_EMAIL_TEMPLATE_STATUS]: (state, action) => {
    const { status } = action.payload;
    return {
      ...state,
      status
    };
  }
});

export const setEmailTemplate = data => ({
  type: SET_EMAIL_TEMPLATE,
  payload: { data }
});

export const setEmailTemplateStatus = status => ({
  type: SET_EMAIL_TEMPLATE_STATUS,
  payload: { status }
});

export const getEmailTemplateSaga = () => ({
  type: GET_EMAIL_TEMPLATE
});

export default emailTemplateReducer;
